export default "__VITE_ASSET__ag6MLAa5__"